import React from 'react';
import { createSvgIcon } from '@mui/material/utils';

// QSレポートアイコン
export default createSvgIcon(
  <g>
    <path d="M5.613 15.341h9.491v.908H5.613z" />
    <path d="M5.613 12.124h9.491v.905H5.613z" />
    <path d="M5.613 8.902h9.491v.908H5.613z" />
    <path d="M10.111 5.684h4.471v.908h-4.471z" />
    <path d="M18.723 18.527V2.752a1.6 1.6 0 0 0-.027-.3A1.82 1.82 0 0 0 16.883 1H9.427a2.07 2.07 0 0 0-1.426.564L3.348 6a1.9 1.9 0 0 0-.591 1.363v11.164a1.8 1.8 0 0 0 1.841 1.752h12.285a1.8 1.8 0 0 0 1.84-1.752ZM8.775 2.218v3.94c0 .427-.174.593-.619.593H4.024ZM3.79 18.527V7.626h4.918a1 1 0 0 0 .448-.1.94.94 0 0 0 .433-.413.87.87 0 0 0 .107-.421V1.985h7.188a.8.8 0 0 1 .74.468.7.7 0 0 1 .064.3v15.774a.79.79 0 0 1-.8.767H4.598a.79.79 0 0 1-.808-.767Z" />
    <path d="M19.405 3.721h-1.24l.064.985h1.176a.786.786 0 0 1 .8.767v15.775a.79.79 0 0 1-.8.767H7.117a.81.81 0 0 1-.741-.468.8.8 0 0 1-.064-.3v-.686H5.279v.686a1.6 1.6 0 0 0 .028.3A1.82 1.82 0 0 0 7.117 23h12.288a1.8 1.8 0 0 0 1.838-1.752V5.473a1.8 1.8 0 0 0-1.838-1.752Z" />
  </g>,
  'QSReportIcon'
);
